import { discount } from './modules/discount'
import {recoveryRules} from './modules/recoveryRules'
import {promotionalDiscounts} from './modules/promotionalDiscounts'
const SaleLayOut = () => import(/*webpackChunkName:'sale'*/'@/page/sale/saleLayOut.vue')
export const sale={
    path:'/sale',
    component:SaleLayOut,
    redirect:'/main/discount/posList',
    children:[
        discount,
        recoveryRules,
        promotionalDiscounts
    ]
}